// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1iGUu","content":"ManualTimeModal_content__XHvic"};